import PhotoSwipeLightbox from '//www.theseedsoflife.net/cdn/shop/t/14/assets/ben-vendor-photoswipe-photoswipe-lightbox.esm.min.js?v=13651888854280649141792646503';

const graduationLightbox = new PhotoSwipeLightbox({
  gallery: '.graduates-photos',
  children: 'a',
  pswpModule: () => import('//www.theseedsoflife.net/cdn/shop/t/14/assets/ben-vendor-photoswipe-photoswipe.esm.min.js?v=63091533421035891871792646504'),
});
graduationLightbox.init();

const gallery = document.querySelector('.story-gallery');
const main = gallery.querySelector('.story-main');
const photo = main.querySelector('img');
const thumbnails = gallery.querySelector('.story-thumbnails');
const response = { ok: true, json: async () => JSON.parse(document.getElementById('story-photos').textContent) };
if (!response.ok) throw new Error('Photo list could not load');
const photos = await response.json();
let current = 0;

function dailyStartingIndex(length) {
  const today = new Date();
  const dateKey = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  let hash = 0;
  for (const character of dateKey) hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  return hash % length;
}

const lightbox = new PhotoSwipeLightbox({
  dataSource: photos.map(item => ({ ...item, msrc: item.thumb })),
  pswpModule: () => import('//www.theseedsoflife.net/cdn/shop/t/14/assets/ben-vendor-photoswipe-photoswipe.esm.min.js?v=63091533421035891871792646504'),
  returnFocus: true,
});
lightbox.init();
lightbox.on('change', () => select(lightbox.pswp.currIndex));

function select(index) {
  current = (index + photos.length) % photos.length;
  const item = photos[current];
  photo.src = item.src;
  photo.alt = item.alt;
  photo.width = item.width;
  photo.height = item.height;
  main.href = item.src;
  gallery.querySelector('.story-stage').textContent = String(current + 1).padStart(2, '0') + ' / ' + photos.length + ' · ' + item.stage;
  gallery.querySelector('.story-title').textContent = item.title;
  [...thumbnails.children].forEach((button, i) => button.setAttribute('aria-current', String(i === current)));
  const active = thumbnails.children[current];
  if (active) thumbnails.scrollTo({ left: active.offsetLeft - thumbnails.offsetLeft - thumbnails.clientWidth / 2 + active.clientWidth / 2, behavior: 'instant' });
}
photos.forEach((item, i) => {
  const button = document.createElement('button');
  button.type = 'button';
  button.setAttribute('aria-label', 'Photograph ' + (i + 1) + ': ' + item.title);
  button.title = item.title;
  const image = document.createElement('img');
  image.src = item.thumb; image.alt = ''; image.loading = 'lazy';
  button.append(image);
  button.addEventListener('click', () => select(i));
  thumbnails.append(button);
});
main.addEventListener('click', event => {
  event.preventDefault();
  if (swiped) { swiped = false; return; }
  lightbox.loadAndOpen(current);
});
gallery.querySelector('[data-story-prev]').addEventListener('click', () => select(current - 1));
gallery.querySelector('[data-story-next]').addEventListener('click', () => select(current + 1));
gallery.addEventListener('keydown', event => {
  if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
    event.preventDefault();
    select(current + (event.key === 'ArrowRight' ? 1 : -1));
  }
});
let start, swiped = false;
main.addEventListener('touchstart', event => { start = event.touches[0]; swiped = false; }, { passive: true });
main.addEventListener('touchend', event => {
  const end = event.changedTouches[0];
  if (start && Math.abs(end.clientX - start.clientX) > 50 && Math.abs(end.clientX - start.clientX) > Math.abs(end.clientY - start.clientY)) {
    swiped = true; select(current + (end.clientX < start.clientX ? 1 : -1));
  }
}, { passive: true });
select(dailyStartingIndex(photos.length));

